import { CIRCULARS } from "../config";
import { get, post } from "./apiHelper";

export const fetchCirculars = () => get(CIRCULARS, { noCache: true });

export const fetchCircular = (id) =>
  get(`${CIRCULARS}/${id}`, { noCache: true });

export const createCircular = (payload) => post(`${CIRCULARS}/create`, payload);

export const updateCircular = (id, payload) =>
  post(`${CIRCULARS}/update/${id}`, payload);

export const deleteCircular = (id) => post(`${CIRCULARS}/delete/${id}`);

export const markCircularRead = (id) => post(`${CIRCULARS}/${id}/read`);

export const remindCircular = (id, recipientIds) =>
  post(`${CIRCULARS}/${id}/remind`, { user_ids: recipientIds });

export const fetchCircularUnreadCount = () =>
  get(`${CIRCULARS}/unread_count`, { noCache: true });
